import ReactDOM from "react-dom";
import React from "react";
import { isEmpty } from "lodash";
import { NO_BLANKS } from "app/list/filters/Constants";

export default class InjectReactFilter {
    constructor(cmp) {
        return class {
            constructor() {
                return new ReactWrapper(cmp);
            }

            //dummy for validation
            getGui() { }
            setModel() { }
            doesFilterPass() { }
        };
    }
}

class ReactWrapper {
    constructor(cmp) {
        this.cmp = cmp;
    }

    init(params) {
        this.agGridProps = params;
        this.el = document.createElement("div");
    }

    getGui() {
        return this.el;
    }

    setModel(model) {
        if (model == this.getModel()) {
            return;
        }

        this.reactComponentStore?.setModel?.(model);
        if (!model) {
            this.value = ""
            this.searchText = "";
            this.agGridProps.filterChangedCallback();
            return;
        }

        // Object.keys(model).forEach(key => {
        //     this[key] = model[key]
        // });
        this.value = model;
        this.searchText = model.searchText ?? "";
        this.agGridProps.filterChangedCallback();
    }

    doesFilterPass({ data, node }) {
        const dataIndex = this.agGridProps.column.colDef.field;
        const columnValue = data[dataIndex] ?? "";
        if (isNaN(parseInt(data.row_id))) {
            return true;
        }
        if(this.agGridProps.column.colDef.aliasPath == "Id"){ 
            if (this.searchText && !columnValue.toString().toLowerCase().startsWith(this.searchText.toLowerCase())) {
                return false;
            } else {
                return true;
            }
        }
        if (this.searchText && !columnValue.toString().toLowerCase().includes(this.searchText.toLowerCase())) {
            return false;
        }

        if (
          this.value?.values &&
          this.value.values.findIndex((val) =>
            val === NO_BLANKS ? columnValue !== "" : val === columnValue
          ) === -1
        ) {
          return false;
        }

        if (this.reactComponentStore?.doesFilterPass && !this.reactComponentStore.doesFilterPass({ data, node })) {
            return false;
        }

        return true;
    }

    afterGuiAttached() {
        const CMP = this.cmp;

        if (this.isRendered && this.reactComponentStore?.loadValues) {
            this.reactComponentStore.loadValues();
            return;
        }
        this.isRendered = true;

        ReactDOM.render(<CMP onChange={this.handleChange} onComponentLoaded={this.setReactComponentContext} {...this.agGridProps} />,
            this.el
        );
    }

    setReactComponentContext = (cmp) => {
        this.reactComponentStore = cmp;
        if (this.value) {
            this.reactComponentStore?.setModel?.(this.value);
        }
    }

    isFilterActive() {
        return !!this.getModel();
    }

    getModel() {
        if (isEmpty(this.value) && !this.searchText) {
            return null;
        }
        return (
            { ...this.value, searchText: this.searchText ?? "" }
            // ??
            // this.cmp.prototype.getDefaultValue?.(this.agGridProps) ??
            // this.agGridProps.value
        );
    }

    onFloatingFilterChanged(searchText) {
        this.searchText = searchText ?? "";
        this.agGridProps.filterChangedCallback();
    }
    // isPopup() {
    //     return this.cmp.prototype.isPopup?.() ?? false;
    // }

    handleChange = (value) => {
        this.value = value;
        this.agGridProps.filterChangedCallback();
    };

    destroy() {
        ReactDOM.unmountComponentAtNode(this.el);
    }
}
